<!-- 听文章 -->
<template>
  <div class="page-article-listen" :class="{ mobile: isMobile }">
    <div class="header">
      <div class="back" @click="back">
        <img src="@imgs/digital/to-paper.png" />
      </div>
      <div class="title">{{ title }}</div>
    </div>
    <div class="main">
      <div class="edition" :class="{ edition_book: bookDetail.listenStyle === 1 }" v-for="(edition, index) in editions" :key="index">
        <div class="title" v-if="bookDetail.listenStyle !== 1">{{ edition.edition }}</div>
        <div class="article-list">
          <div class="article-item" v-for="article in edition.xiaoYangList" :key="article.id" :class="{ active: xiaoYangId == article.id }" @click="handleXiaoYangClick(article.id)">
            <el-divider></el-divider>
            <div class="title">{{ article.title }} <img src="@imgs/listen/playing.png" alt="" srcset="" /></div>
          </div>
        </div>
        <el-divider v-if="bookDetail.listenStyle !== 1"></el-divider>
      </div>
    </div>
    <div class="bottom">
      <div class="left" @click="prev" :class="[xiaoYangIndex != 0 ? 'useable' : 'disable']">
        <img src="@imgs/listen/left_play_active.png" class="activeImg" alt="" srcset="" />
        <img src="@imgs/listen/left_play_inactive.png" class="inActiveImg" alt="" srcset="" />
        上一篇
      </div>
      <div class="center" @click="resumeAudio">
        <img src="@imgs/listen/play.png" alt="" srcset="" v-show="isPause" />
        <img src="@imgs/listen/pause.png" alt="" srcset="" v-show="!isPause" />
      </div>
      <div class="right" @click="next" :class="[xiaoYangIndex != xiaoYangList.length - 1 ? 'useable' : 'disable']">
        下一篇
        <img src="@imgs/listen/right_play_active.png" class="activeImg" alt="" srcset="" />
        <img src="@imgs/listen/right_play_inactive.png" class="inActiveImg" alt="" srcset="" />
      </div>
    </div>
    <audio v-if="xiaoYangList.length > 0" id="articleAudio" :src="xiaoYangList[xiaoYangIndex].audio" @ended="next"></audio>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      dataLoading: false,
      isPause: true,
      title: '',
      editions: [],
      bookDetail: {},
      xiaoYangList: [],
      xiaoYangIndex: 0,
      id: '', //报纸或者书刊id
      articleText: '',
      readStatus: false,
      voices: ['x3_guange', 'x4_lingxiaoying_en', 'x2_wanshu', 'xiaoyan', 'aisjiuxu', 'aisxping', 'aisjinger', 'aisbabyxu']
    }
  },
  destroyed() {
    const audio = document.getElementById('articleAudio')
    audio.pause()
  },
  watch: {
    xiaoYangIndex() {
      this.read()
    }
  },
  methods: {
    back() {
      if (window.history.length > 1) {
        window.history.go(-1)
      } else {
        this.$router.push('/')
      }
    },
    handleXiaoYangClick(xiaoYangId) {
      this.xiaoYangList.forEach((item, index) => {
        if (item.id === xiaoYangId) {
          this.xiaoYangIndex = index
          return false
        }
      })
    },
    createXiaoYangList() {
      let arr = []
      this.editions.forEach((edition) => {
        if (edition.xiaoYangList) {
          edition.xiaoYangList.forEach((xiaoyang) => {
            arr.push(xiaoyang)
          })
        }
      })
      this.xiaoYangList = arr
    },
    getDetails() {
      this.editions = window.staticOptions.daYangList
      console.log(this.editions)
      // this.title = this.editions[0].baoMing
      if (this.editions.length) {
        this.createXiaoYangList()
      } else {
        this.dataLoading = false
      }
    },
    next() {
      if (this.xiaoYangIndex >= this.xiaoYangList.length - 1) {
        return
      } else {
        this.xiaoYangIndex++
      }
    },
    prev() {
      if (this.xiaoYangIndex <= 0) {
        return
      } else {
        this.xiaoYangIndex--
      }
    },
    resumeAudio() {
      const audio = document.getElementById('articleAudio')
      if (this.isPause) {
        audio.play()
      } else {
        audio.pause()
      }
      this.isPause = !this.isPause
    },
    read() {
      const audio = document.getElementById('articleAudio')
      audio.pause()
      audio.currentTime = 0
      setTimeout(() => {
        audio.play()
        this.isPause = false
      }, 100)
    },
    getBookDetails() {
      this.bookDetail = window.staticOptions
      this.title = this.bookDetail.title
    }
  },
  computed: {
    ...mapState('book', ['isMobile']),
    xiaoYangId() {
      return this.xiaoYangList[this.xiaoYangIndex]?.id
    },
    isPaper() {
      return this.$route.query.type === 'epaper'
    }
  },
  created() {
    this.dataLoading = true
    this.getBookDetails()
    this.getDetails()
  },
  mounted() {
    this.isPause = true
    this.$nextTick(() => {
      $(document).one('click', (e) => {
        this.read()
      })
    })
  }
}
</script>

<style lang="scss">
.page-article-listen {
  width: 600px;
  height: 100%;
  margin: auto;
  border: 1px solid #d2d2d2;
  position: relative;
  .header {
    background-color: #f5f5f5;
    padding: 0 7px;
    position: relative;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    .back {
      position: absolute;
      left: 0;
      top: 0;
      height: 40px;
      text-align: left;
      line-height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        margin-right: 3px;
        height: 27px;
      }
      span {
        line-height: 40px;
      }
    }
    .title {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      font-size: 16px;
      text-overflow: ellipsis;
      width: calc(100% - 90px);
      margin-left: 60px;
    }
  }
  .main {
    overflow: auto;
    height: calc(100% - 40px - 95px);
    padding: 10px 7px;
    font-size: 20px;
    .edition {
      .article-item {
        cursor: pointer;
      }
      > .title {
        color: rgba(223, 88, 19, 1);
        font-weight: 700;
      }
      .title {
        padding: 12px 50px 12px 27px;
        line-height: 36px;
      }
      .el-divider {
        margin: 0;
        background-color: rgba(239, 239, 239, 1);
      }
      > .el-divider {
        height: 4px;
      }
      img {
        position: absolute;
        width: 16px;
        height: 20px;
        right: 20px;
        top: 0;
        bottom: 0;
        margin: auto;
        display: none;
      }
      .active {
        color: rgba(223, 88, 19, 1);
        position: relative;
        .title::before {
          position: absolute;
          content: '';
          width: 8px;
          background: rgba(223, 88, 19, 1);
          left: -8px;
          top: 0;
          bottom: 0;
        }
        img {
          display: block;
        }
      }
    }
    .edition:last-of-type {
      > .el-divider {
        display: none;
      }
    }
  }
  .bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid rgba(229, 229, 229, 1);
    display: flex;
    justify-content: space-around;
    padding: 0 20px;
    align-items: center;
    height: 94px;
    width: 560px;
    margin: auto;
    background-color: #fff;
    color: #000;
    > div {
      padding: 10px 20px;
    }
    img {
      width: 40px;
      height: 40px;
      vertical-align: middle;
    }
    .center {
      img {
        width: 64px;
        height: 64px;
      }
    }
    .inactive {
      color: #9b9aa7;
    }
    .disable {
      cursor: not-allowed;
      .activeImg {
        display: none;
      }
      .inActiveImg {
        display: inline;
      }
    }
    .useable {
      cursor: pointer;
      .activeImg {
        display: inline;
      }
      .inActiveImg {
        display: none;
      }
    }
  }
}
.page-article-listen.mobile {
  border: 0;
  width: 100%;
  .main {
    height: calc(100% - 40px - 110px);
  }
  .bottom {
    margin: 0 15px;
    padding: 15px 0;
    width: calc(100% - 30px);
    height: 110px;
    .left,
    .right,
    .center {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
